import React, { useState } from "react";
import Swal from "sweetalert2";
import ScrollToTop from "../../ScrollToTop";

const RecruitmentAgentForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    confirmEmail: "",
    phoneNumber: "",
    countryRegion: "",
    organisation: "",
    recruitmentExperience: "",
    motivation: "",
    linkedinOrWebsite: "",
    cvFile: null, 
    confirmation: false,
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (type === "checkbox" && name === "confirmation") {
      setFormData({ ...formData, confirmation: checked });
    } else if (type === "file") {
      setFormData({ ...formData, cvFile: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const createFormattedData = () => {
    const formattedData = new FormData();

    formattedData.append("_subject", "New Recruitment Agent Application");
    formattedData.append("_captcha", "false");
    formattedData.append("_template", "table");

    Object.entries(formData).forEach(([key, value]) => {
      if (value instanceof File) {
        if (value) {
          formattedData.append(key, value);
        }
      } else {
        formattedData.append(key, value);
      }
    });

    return formattedData;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.email !== formData.confirmEmail) {
      Swal.fire({
        icon: "error",
        title: "Emails do not match",
        text: "Please ensure both email fields match.",
      });
      return;
    }

    if (!formData.confirmation) {
      Swal.fire({
        icon: "error",
        title: "Please confirm",
        text: "You must confirm that your information is accurate.",
      });
      return;
    }

    setIsSubmitting(true);

    const formSubmitEndpoint =
      "https://formsubmit.co/sapphirediplomacyleadership@gmail.com";

    const data = createFormattedData();

    Swal.fire({
      title: "Submitting your application...",
      text: "Please wait a moment.",
      icon: "info",
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      const response = await fetch(formSubmitEndpoint, {
        method: "POST",
        body: data,
      });

      setIsSubmitting(false);

      if (response.ok) {
        Swal.fire({
          title: "Application Submitted!",
          text: "Your recruitment agent application has been sent successfully.",
          icon: "success",
        });
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          confirmEmail: "",
          phoneNumber: "",
          countryRegion: "",
          organisation: "",
          recruitmentExperience: "",
          motivation: "",
          linkedinOrWebsite: "",
          cvFile: null,
          confirmation: false,
        });
      } else {
        Swal.fire({
          title: "Submission Error",
          text: "There was an issue submitting your application. Please try again later.",
          icon: "error",
        });
      }
    } catch (error) {
      setIsSubmitting(false);
      Swal.fire({
        title: "Network Error",
        text: "Please check your connection & try again.",
        icon: "error",
      });
    }
  };

  return (
    <div>
      <div
        className=" bg-cover bg-center py-10"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1603573355706-3f15d98cf100?q=80&w=1929&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
        }}
      >
        <ScrollToTop />
        <form
          onSubmit={handleSubmit}
          className=" md:p-10 px-2 py-5 mx-2 my-4 bg-blue-200 bg-opacity-70 backdrop-blur-sm border border-black rounded-md max-w-lg md:mx-auto"
        >
          <h2 className="text-2xl font-bold mb-6 text-center">
            Become Our Recruitment Agent
          </h2>

          <div className="flex gap-4 mb-4">
            <input
              type="text"
              name="firstName"
              placeholder="First Name"
              value={formData.firstName}
              onChange={handleChange}
              className="w-1/2 p-2 border rounded"
              required
            />
            <input
              type="text"
              name="lastName"
              placeholder="Last Name"
              value={formData.lastName}
              onChange={handleChange}
              className="w-1/2 p-2 border rounded"
              required
            />
          </div>
          <input
            type="email"
            name="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={handleChange}
            className="w-full p-2 mb-4 border rounded"
            required
          />

          <input
            type="email"
            name="confirmEmail"
            placeholder="Confirm Email Address"
            value={formData.confirmEmail}
            onChange={handleChange}
            className="w-full p-2 mb-4 border rounded"
            required
          />
          <input
            type="tel"
            name="phoneNumber"
            placeholder="Phone Number (with country code)"
            value={formData.phoneNumber}
            onChange={handleChange}
            className="w-full p-2 mb-4 border rounded"
            required
          />
          <input
            type="text"
            name="countryRegion"
            placeholder="Country / Region"
            value={formData.countryRegion}
            onChange={handleChange}
            className="w-full p-2 mb-4 border rounded"
            required
          />
          <input
            type="text"
            name="organisation"
            placeholder="Organisation (if applicable)"
            value={formData.organisation}
            onChange={handleChange}
            className="w-full p-2 mb-4 border rounded"
          />
          <textarea
            name="recruitmentExperience"
            placeholder="Experience in Student Recruitment (max 150 words)"
            value={formData.recruitmentExperience}
            onChange={handleChange}
            rows={4}
            className="w-full p-2 mb-4 border rounded resize-y"
            required
          />
          <textarea
            name="motivation"
            placeholder="Why are you interested in working with ESBD? (max 100 words)"
            value={formData.motivation}
            onChange={handleChange}
            rows={4}
            className="w-full p-2 mb-4 border rounded resize-y"
            required
          />
          <input
            type="url"
            name="linkedinOrWebsite"
            placeholder="LinkedIn Profile or Website (optional)"
            value={formData.linkedinOrWebsite}
            onChange={handleChange}
            className="w-full p-2 mb-4 border rounded"
          />
          <input
            type="file"
            name="cvFile"
            accept=".pdf,.doc,.docx"
            onChange={handleChange}
            className="w-full p-2 mb-4 border rounded"
          />
          <label className="flex items-center mb-4 space-x-2">
            <input
              type="checkbox"
              name="confirmation"
              checked={formData.confirmation}
              onChange={handleChange}
              required
            />
            <span>
              I confirm that the information provided is accurate and agree to
              be contacted by ESBD regarding this opportunity.
            </span>
          </label>
          <button
            type="submit"
            disabled={isSubmitting}
            className={`w-full px-6 py-2 mt-5 bg-blue-600 text-white rounded hover:bg-blue-700 ${
              isSubmitting ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            {isSubmitting ? "Submitting..." : "Submit Application"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default RecruitmentAgentForm;
